import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Loader, enumPolicies} from '../../../_metronic/helpers'
import { useAuth } from '../../../app/modules/auth'
import Users from './users'
import Dealers from './dealers'
import Customers from '../customer-management/customers'
import Suppliers from './supplier/suppliers'
import {clearState as clearUserState, getUserList} from './userActions'
import {
  clearState as clearCustomerState,
  getCustomerList,
} from '../customer-management/customerActions'
import PolicyChecker from '../../../_metronic/helpers/components/PolicyChecker'

const UserPage = (props) => {
  const intl = useIntl();
  const { currentUser } = useAuth();
  const [activeTab, setActiveTab] = useState()

  useEffect(() => {
    if (currentUser && currentUser.policyIds) {
      if (
        currentUser.policyIds.some(
          (policy) =>
            policy === enumPolicies.UserRead ||
            policy === enumPolicies.UserWrite ||
            policy === enumPolicies.UserEdit
        )
      )
        setActiveTab('users')
      else if (currentUser.policyIds.some((policy) => policy === enumPolicies.UserDealerRead))
        setActiveTab('dealers')
      else if (
        currentUser.policyIds.some(
          (policy) =>
            policy === enumPolicies.CustomerRead ||
            policy === enumPolicies.CustomerWrite ||
            policy === enumPolicies.CustomerEdit
        )
      )
        setActiveTab('customers')
      else if (
        currentUser.policyIds.some(
          (policy) =>
            policy === enumPolicies.ProductRead ||
            policy === enumPolicies.ProductWrite ||
            policy === enumPolicies.ProductEdit
        )
      )
        setActiveTab('suppliers')
      else setActiveTab('users')
    }
  }, [])

  useEffect(() => {
    if (activeTab === 'users') {
      props.getUserList('', '-1')
    } else if (activeTab === 'dealers') {
      props.getUserList('', 3)
    } else if (activeTab === 'customers') {
      props.getCustomerList({keyword: '', isActive: '', page: 1})
    }
    return () => {
      if (activeTab === 'users' || activeTab === 'dealers') {
        props.clearUserState()
      } else if (activeTab === 'customers') {
        props.clearCustomerState()
      }
    }
  }, [activeTab])

  const breadcrumbs = [
    {
      title: intl.formatMessage({ id: 'USER.MANAGEMENT.TITLE' }),
      path: '/user-management',
      isSeparator: false,
      isActive: false,
    },
    {
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>
        {intl.formatMessage({id: 'USER.LIST.BREADCRUMB'})}
      </PageTitle>
      <div className='card'>
        <div className='card-header card-header-stretch'>
          <div className='card-toolbar'>
            <ul className='nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0'>
              <PolicyChecker policies={[enumPolicies.UserWrite, enumPolicies.UserEdit, enumPolicies.UserRead]}>
                <li className='nav-item'>
                  <button
                    className={`nav-link btn btn-color-gray-600 btn-active-color-primary fw-bolder px-4 me-1 ${
                      activeTab === 'users' && 'active'
                    }`}
                    onClick={() => setActiveTab('users')}
                  >
                    {intl.formatMessage({id: 'USER.TITLE'})}
                  </button>
                </li>
              </PolicyChecker>
              <PolicyChecker policies={[enumPolicies.UserDealerRead]}>
                <li className='nav-item'>
                  <button
                    className={`nav-link btn btn-color-gray-600 btn-active-color-primary fw-bolder px-4 me-1 ${
                      activeTab === 'dealers' && 'active'
                    }`}
                    onClick={() => setActiveTab('dealers')}
                  >
                    {intl.formatMessage({id: 'USER.TYPES.DEALER'})}
                  </button>
                </li>
              </PolicyChecker>
              <PolicyChecker
                policies={[enumPolicies.CustomerRead, enumPolicies.CustomerEdit, enumPolicies.CustomerWrite]}
              >
                <li className='nav-item'>
                  <button
                    className={`nav-link btn btn-color-gray-600 btn-active-color-primary fw-bolder px-4 me-1 ${
                      activeTab === 'customers' && 'active'
                    }`}
                    onClick={() => setActiveTab('customers')}
                  >
                    {intl.formatMessage({id: 'USER.TYPES.CUSTOMER'})}
                  </button>
                </li>
              </PolicyChecker>
              <PolicyChecker
                policies={[
                  enumPolicies.ProductRead,
                  enumPolicies.ProductEdit,
                  enumPolicies.ProductWrite
                ]}
              >
                <li className='nav-item'>
                  <button
                    className={`nav-link btn btn-color-gray-600 btn-active-color-primary fw-bolder px-4 me-1 ${
                      activeTab === 'suppliers' && 'active'
                    }`}
                    onClick={() => setActiveTab('suppliers')}
                  >
                    {intl.formatMessage({id: 'USER.TYPES.SUPPLIER'})}
                  </button>
                </li>
              </PolicyChecker>
            </ul>
          </div>
        </div>
        <div className='card-body'>
          <>
            {activeTab === 'users' && <Users />}
            {activeTab === 'dealers' && <Dealers />}
            {activeTab === 'customers' && <Customers />}
            {activeTab === 'suppliers' && <Suppliers />}
          </>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.User.loading || state.Customer.loading,
});

const mapDispatchToProps = {
  clearUserState,
  clearCustomerState,
  getUserList,
  getCustomerList,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPage);
